(() => {
  "use strict";

  const device = () => window.matchMedia("(max-width: 727px)").matches ? "mobile" : "desktop";

  const track = action => {
    const ad = action.closest("[data-hte-site-ad]");
    if (!ad) return;

    const detail = {
      event: "heytaos_ad_click",
      page: ad.dataset.hteAdPage || document.title || "HeyTaos",
      page_path: ad.dataset.hteAdPagePath || window.location.pathname,
      placement: ad.dataset.hteSiteAd || ad.dataset.hteAd || "unknown",
      placement_type: ad.dataset.hteAdPlacementType || ad.dataset.hteSiteAd || "unknown",
      creative_size: ad.dataset.hteAdCreativeSize || "unknown",
      source: action.dataset.hteSiteAdSource || action.dataset.hteAdClickSource || "creative",
      device: device()
    };

    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", "heytaos_ad_click", {
          event_category: "advertising",
          page: detail.page,
          page_path: detail.page_path,
          placement: detail.placement,
          placement_type: detail.placement_type,
          creative_size: detail.creative_size,
          source: detail.source,
          device: detail.device
        });
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(detail);
      }
    } catch (_) {}

    try {
      window.dispatchEvent(new CustomEvent("heytaos:ad-click", { detail }));
    } catch (_) {}
  };

  const normalize = value => String(value || "").replace(/\s+/g, " ").trim().toLowerCase();

  const headingBoundary = text => {
    const target = normalize(text);
    if (!target) return null;
    const heading = [...document.querySelectorAll("h2,h3")].find(node => normalize(node.textContent) === target);
    if (!heading) return null;
    return heading.closest("section") || heading.parentElement;
  };

  const resolveAnchor = (layout, slot) => {
    const selector = layout.dataset[`hte${slot}Selector`];
    if (selector) {
      try {
        const selected = document.querySelector(selector);
        if (selected) return selected;
      } catch (_) {}
    }
    return headingBoundary(layout.dataset[`hte${slot}Heading`]);
  };

  const insert = (layout, slot) => {
    const template = layout.parentElement?.querySelector(`template[data-hte-ad-template="${slot.toLowerCase()}"]`)
      || document.querySelector(`template[data-hte-ad-template="${slot.toLowerCase()}"]`);
    if (!template) return false;

    const anchor = resolveAnchor(layout, slot);
    if (!anchor) return false;

    const node = template.content.firstElementChild?.cloneNode(true);
    if (!node) return false;

    const position = normalize(layout.dataset[`hte${slot}Position`]) || "after";
    if (position === "before") anchor.insertAdjacentElement("beforebegin", node);
    else anchor.insertAdjacentElement("afterend", node);
    return true;
  };

  const placeConfiguredAds = () => {
    document.querySelectorAll("[data-hte-ad-layout]").forEach(layout => {
      if (layout.dataset.hteAdsPlaced === "true") return;
      const primaryPlaced = insert(layout, "Primary");
      const secondaryRequired = layout.dataset.hteSecondaryEnabled === "true";
      const secondaryPlaced = secondaryRequired ? insert(layout, "Secondary") : true;
      if (primaryPlaced && secondaryPlaced) layout.dataset.hteAdsPlaced = "true";
    });
  };

  if (!window.__heyTaosAdvertisingTrackingBound) {
    window.__heyTaosAdvertisingTrackingBound = true;
    document.addEventListener("click", event => {
      const action = event.target.closest?.("[data-hte-site-ad-click]");
      if (action) track(action);
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", placeConfiguredAds, { once: true });
  } else {
    placeConfiguredAds();
  }
})();
